import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import { FormState } from 'common/entities/form/FormTypes';
import Input from 'common/components/form/inputs/Input';
import VesselSelector from 'common/components/selectors/VesselSelector';

import Remarks from './Remarks';

const Wrapper = ({ formState, isOcean, isEditDisabled, children }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <Row className="d-flex flex-column pb-2">
      <Col xs={12}>
        <Row>
          <Col xs={3}>
            <Input
              label="NAME"
              placeholder="Add name"
              disabled={isEditDisabled}
              onChange={changeField('name')}
              {...fields.name}
            />
          </Col>

          {isOcean ? null : (
            <Col xs={9}>
              <VesselSelector
                isMulti={true}
                isClearable
                autoFocus={false}
                className="mb-0"
                onChange={selectField('vessels')}
                placeholder="Select vessel"
                label="Applicable Vessels"
                {...fields.vessels}
              />
            </Col>
          )}
        </Row>
      </Col>

      <Col xs={12}>{children}</Col>

      <Col xs={12}>
        <Remarks
          disabled={isEditDisabled}
          onChange={e => selectField('remarks')(e.target.value)}
          {...fields.remarks}
        />
      </Col>
    </Row>
  );
};

export default Wrapper;

Wrapper.propTypes = {
  formState: FormState,
  children: PropTypes.node,
  isOcean: PropTypes.bool,
  isEditDisabled: PropTypes.bool
};
